import DescriptionIcon from '@mui/icons-material/Description'
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto'
import { Box } from '@mui/material'
import React from 'react'
import PictureAsPdfIcon from '../../images/icons/PDF_file_icon.svg'

const AttachmentThumb = ({ attachment }: { attachment: any }) => {
  const [failed, setFailed] = React.useState(false)

  const isImage = attachment.mimeType?.startsWith('image/')
  const isPdf = attachment.mimeType === 'application/pdf'

  // Prefer thumbnailLink for images; fall back to iconLink/url only if you want.
  const src = attachment.thumbnailLink || attachment.iconLink || attachment.url

  // A consistent square tile for non-PDF thumbs
  const tileSx = {
    width: '100%',
    height: '100%',
    borderRadius: 1,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: 'action.hover',
  } as const

  if (isPdf) {
    return (
      <Box sx={tileSx}>
        <img src={PictureAsPdfIcon} alt="PDF" style={{ width: '80%', height: '80%', objectFit: 'contain' }} />
      </Box>
    )
  }

  if (isImage) {
    // If image src is missing or failed to load, show icon fallback
    if (!src || failed) {
      return (
        <Box sx={tileSx}>
          <InsertPhotoIcon sx={{ color: 'text.secondary' }} />
        </Box>
      )
    }

    return (
      <Box sx={tileSx}>
        <Box
          component="img"
          src={src}
          alt={attachment.name ?? 'image'}
          onError={() => setFailed(true)} // ✅ fallback on load failure
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Box>
    )
  }

  // default / unknown file types
  return (
    <Box sx={tileSx}>
      <DescriptionIcon sx={{ color: 'text.secondary' }} />
    </Box>
  )
}
export default AttachmentThumb
